<template>
  <v-container fluid grid-list-lg :class="$vuetify.breakpoint.name !== 'xs' ? 'fill-height' : ''">
    <v-layout align-center row wrap>
      <v-flex x12 sm6 offset-sm3>
        <v-card>
          <v-form
            autocomplete="off"
            lazy-validation
            name="form"
            ref="form"
            v-model="valid"
          >
            <v-card-title>
              <h3>Password Reset</h3>
            </v-card-title>

            <v-card-text class="pb-0 pt-0">
              <div class="boxHeader mb-4">
                Password requirements:
                <ul>
                  <li>Must be eight characters or longer</li>
                  <li>Must contain at least one upper case letter (A-Z)</li>
                  <li>Must contain at least one lower case letter (a-z)</li>
                  <li>Must contain at least one digit (0-9)</li>
                </ul>
              </div>

              <v-text-field
                append-icon="fa-user"
                autofocus
                box
                label="Email"
                required
                :rules="emailRules"
                v-model="email"
              ></v-text-field>

              <v-text-field
                :append-icon="showNewPassword ? 'visibility' : 'visibility_off'"
                autocomplete="off"
                box
                @click:append="showNewPassword = !showNewPassword"
                label="New Password"
                required
                :rules="passwordRules"
                :type="showNewPassword ? 'text' : 'password'"
                v-model="newPassword"
              ></v-text-field>

              <v-text-field
                :append-icon="showConfirmPassword ? 'visibility' : 'visibility_off'"
                autocomplete="off"
                box
                @click:append="showConfirmPassword = !showConfirmPassword"
                label="Confirm Password"
                required
                :rules="passwordVerifyRules"
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="confirmPassword"
              ></v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-btn
                block
                class="ma-2"
                @click="change"
                color="primary"
                :disabled="!valid || loading"
                :loading="loading"
                large
              >reset password</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Bus from '@/bus'

import APIMixin from '@/mixins/api'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [APIMixin, StoreMixin],

  data: function () {
    return {
      email: '',
      // token: this.$route.params.token,
      newPassword: '',
      confirmPassword: '',
      showNewPassword: false,
      showConfirmPassword: false,
      valid: false,
      loading: false,

      emailRules: [
        (v) => !!v || 'Email is required',
        (v) => !v || /.+@.+/.test(v) || 'Email must be valid'
      ],
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => (v.length > 7) || 'Password must be eight characters or longer',
        (v) => (v.match(/[A-Z]/) && v.match(/[a-z]/) && v.match(/[1-9]/)) || 'Password must contain one uppercase character, one lowercase character, and a digit'
        // (v) => (v.toString() === this.fields.ach_account_number_verify) || 'Account number does not match verification'
      ],
      passwordVerifyRules: [
        (v) => (v.toString() === this.newPassword) || 'Password verification does not match'
      ]
    }
  },

  methods: {
    async change () {
      try {
        if (!this.$route.params.token) {
          throw new Error('Invalid token')
        }

        this.loading = true

        await this.api({
          method: 'put',
          url: `/users/password_reset_verify`,
          data: {
            email: this.email,
            token: this.$route.params.token,
            password: this.newPassword
          }
        })
        this.$store.commit('forceChangePassword', false)
        Bus.$emit('openModal', {
          status: 'info',
          message: 'Your password has been changed'
        })
        this.$router.push('/')
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue